// extracted by mini-css-extract-plugin
export default {"rallycard":"RallyCard_rallycard__LhFAx"};